import { lazy } from 'react';
import { createBrowserRouter } from 'react-router-dom';
import Loadable from 'components/Loadable';

// project imports
import MainRoutes from './MainRoutes';
import LoginRoutes from './LoginRoutes';
import PublicRoutes from './PublicRoutes';
import PortalRoutes from './PortalRoutes';
import Error404 from 'pages/maintenance/Error404';
import Error500 from 'pages/maintenance/Error500';

// Pública: CSAT — sem auth, link por token
const CsatResponderPage = Loadable(lazy(() => import('pages/portal/csat/CsatResponderPage')));
// Pública: Relatório de andamento de projeto — read-only, link por token
const StatusReportPublicoPage = Loadable(lazy(() => import('pages/public/StatusReportPublicoPage')));
// Pública: credencial compartilhada do Cofre — link por token (TTL/burn/passphrase)
const CofreLinkPublicoPage = Loadable(lazy(() => import('pages/public/CofreLinkPublicoPage')));
// Pública: fatura do mês — read-only, link por token (é o plano B quando o dossiê não cabe em anexo)
const FaturaPublicaPage = Loadable(lazy(() => import('pages/public/FaturaPublicaPage')));

// Públicas do CRM: o convidado escolhe o horário e cancela sem ter conta no Rocky.
const AgendamentoPublicoPage = Loadable(lazy(() => import('pages/crm/agendamento/AgendamentoPublicoPage')));
const AgendamentoCancelarPage = Loadable(lazy(() => import('pages/crm/agendamento/AgendamentoCancelarPage')));
// Pública do CRM: duplo opt-in — o titular confirma por clique que autoriza o contato.
const ConsentimentoConfirmarPage = Loadable(lazy(() => import('pages/crm/consentimento/ConsentimentoConfirmarPage')));

// ==============================|| ROUTING RENDER ||============================== //

const router = createBrowserRouter(
  [
    {
      ...PublicRoutes,
      errorElement: <Error500 />
    },
    {
      path: '/csat/:token',
      element: <CsatResponderPage />,
      errorElement: <Error500 />
    },
    {
      path: '/r/:token',
      element: <StatusReportPublicoPage />,
      errorElement: <Error500 />
    },
    // A de cancelar vem antes da de slug de propósito: "cancelar" é um slug válido, e na ordem
    // inversa o link do e-mail cairia na página de marcação.
    {
      path: '/agendar/cancelar/:token',
      element: <AgendamentoCancelarPage />,
      errorElement: <Error500 />
    },
    {
      path: '/agendar/:slug',
      element: <AgendamentoPublicoPage />,
      errorElement: <Error500 />
    },
    {
      path: '/consentimento/:token',
      element: <ConsentimentoConfirmarPage />,
      errorElement: <Error500 />
    },
    {
      path: '/cofre/s/:token',
      element: <CofreLinkPublicoPage />,
      errorElement: <Error500 />
    },
    {
      path: '/f/:token',
      element: <FaturaPublicaPage />,
      errorElement: <Error500 />
    },
    {
      ...PortalRoutes,
      errorElement: <Error500 />
    },
    {
      ...MainRoutes,
      errorElement: <Error500 />
    },
    {
      ...LoginRoutes,
      errorElement: <Error500 />
    },
    {
      path: '*',
      element: <Error404 />,
      errorElement: <Error500 />
    }
  ],
  { basename: import.meta.env.VITE_APP_BASE_NAME }
);

export default router;
